export default {
    RECEM_NASCIDO: 1,
    CRIANCA: 2,
    OUTRO: 3,
}